import React, { Component, useEffect, useState } from "react";
import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import Home from "./pages/Home";
// import {ChatFullpage} from "./pages/Chat";

import Login from "./pages/Login";
import CompleteRegistration from "./pages/CompleteRegistration";
import ResetPassword from "./pages/ResetPassword";
import { auth, db } from "./services/firebase";
import Header from "./components/Header";
import Board from "./pages/Board";
import Gallery from "./pages/Gallery";
import RealtimeChat from "./pages/RealtimeChat";
import RealtimeChatAdmin from "./pages/RealtimeChatAdmin";
import "./css/styles.css";

import {
  checkCurrentUserDbData,
  createUserInDb,
} from "./helpers/userManagement";
import { addUserToWorkshop } from "./helpers/factory";
import { Icon } from "react-materialize";
import { setDataInDb } from "./helpers/db";

function PrivateRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated === true ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{ pathname: "/login", state: { from: props.location } }}
          />
        )
      }
    />
  );
}

function PublicRoute({ component: Component, authenticated, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        authenticated === false ? (
          <Component {...props} />
        ) : (
          <Redirect to="/board" />
        )
      }
    />
  );
}

function GlobalMessage({ message, setMessage }) {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (message.text) {
      setIsVisible(true);
    }
  }, [message]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => setMessage({ text: '', type: '' }), 300);
  };

  if (!isVisible) return null;

  const backgroundColor = 
    message.type === "error" ? "red" : 
    message.type === "warning" ? "orange" : "green";

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        backgroundColor,
        color: "white",
        padding: "10px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
        marginBottom: "20px",
        opacity: isVisible ? 1 : 0,
        transition: "opacity 0.3s ease-in-out",
        zIndex: 10,
      }}
    >
      <p style={{ margin: 0 }}>{message.text}</p>
      <Icon 
        style={{ cursor: "pointer" }}
        onClick={handleClose}
      >
        close
      </Icon>
    </div>
  );
}

class App extends Component {
  constructor() {
    super();
    this.state = {
      authenticated: false,
      loading: true,
      message: { text: "", type: "" }
    };
  }
  setMessage = (message) => {
    this.setState({ message });
  }

  componentDidMount() {
    const isLoginPage = window.location.pathname === "/login";
    const searchParams = new URLSearchParams(window.location.search);
    const urlWorkshopId = searchParams.get("workshop");
    const localWorkshopId = window.localStorage.getItem("workshopIdForSignIn") === "null" ? null : window.localStorage.getItem("workshopIdForSignIn");
    const workshopId =
      urlWorkshopId && localWorkshopId
        ? urlWorkshopId
        : !urlWorkshopId
        ? localWorkshopId
        : urlWorkshopId;

    let localName = window.localStorage.getItem("nameForSignUp") || searchParams.get("name");
    let localUserType = window.localStorage.getItem("userTypeForSignUp") || searchParams.get("usertype");
    let localInstitutionId = window.localStorage.getItem("institutionIdForSignUp") || searchParams.get("institution");
    let localBio = window.localStorage.getItem("bioForSignUp") || searchParams.get("bio");
    let localLocation = window.localStorage.getItem("locationForSignUp") || searchParams.get("location");

    searchParams.delete("name");
    searchParams.delete("usertype");
    searchParams.delete("institution");
    searchParams.delete("bio");
    searchParams.delete("location");

    auth().onAuthStateChanged(async (user) => {
    // console.log("name", localName, window.localStorage.getItem("nameForSignUp"), searchParams.get("name"))
    // console.log("userType", localUserType, window.localStorage.getItem("userTypeForSignUp"), searchParams.get("usertype"))
    // console.log("institution", localInstitutionId, window.localStorage.getItem("institutionIdForSignUp"), searchParams.get("institution"))
    // console.log("bio", localBio, window.localStorage.getItem("bioForSignUp"), searchParams.get("bio"))
    // console.log("location", localLocation, window.localStorage.getItem("locationForSignUp"), searchParams.get("location"))

      if (user && user.emailVerified) {
        if (isLoginPage) {
          if (
            localName ||
            localUserType ||
            localInstitutionId ||
            localBio ||
            localLocation
          ) {
            // Fill user signup
            await createUserInDb(
              {
                name: localName,
                email: user.email,
                bio: localBio,
                location: localLocation,
              },
              localUserType,
              localInstitutionId,
              workshopId,
              user.uid
            );

            localName = null;
            localUserType = null;
            localInstitutionId = null;
            localBio = null;
            localLocation = null;

            window.localStorage.removeItem("nameForSignUp");
            window.localStorage.removeItem("userTypeForSignUp");
            window.localStorage.removeItem("institutionIdForSignUp");
            window.localStorage.removeItem("bioForSignUp");
            window.localStorage.removeItem("locationForSignUp");
            window.localStorage.removeItem("workshopIdForSignIn");

            this.setMessage({text: "Registration completed !", type: "success"});
          } else if (workshopId) {
            // Add to workshop
            await setDataInDb("users", user.uid, {
              currentWorkshop: workshopId,
            }, true); 
            await db.collection("users")
              .doc(user.uid)
              .get()
              .then(async (doc) => {
                if (doc.exists) {
                  const userData = doc.data();
                  const userType = userData.type;
                  await addUserToWorkshop(user.uid, workshopId, userType);
                  window.localStorage.removeItem("workshopIdForSignIn");
                  this.setMessage({text: "You have been successfully added to the workshop !", type: "success"});
                }
              })
              .catch((error) => {
                console.error("Error fetching user data:", error);
              });
          }
        }
        this.setState({
          authenticated: true,
          loading: false,
        });
        checkCurrentUserDbData();
      } else {
        this.setState({
          authenticated: false,
          loading: false,
        });
        window.localStorage.setItem("workshopIdForSignIn", workshopId);
      }
    });
  }

  render() {
    return this.state.loading === true ? (
      <div className="spinner-border text-success" role="status">
        <span className="sr-only">Loading...</span>
      </div>
    ) : (
      <Router>
        <GlobalMessage message={this.state.message} setMessage={this.setMessage} />
        <Header />
        <Switch>
          <Route
            exact
            path="/"
            component={this.state.authenticated ? Board : Home}
          />
          <Route
            path="/completeRegistration"
            component={CompleteRegistration}
          />
          <Route path="/resetpassword" component={ResetPassword} />
          <Route path="/gallery" component={Gallery} />
          <Route path="/realtimechat" component={RealtimeChat} />
          <Route path="/realtimechatadmin" component={RealtimeChatAdmin} />

          <PrivateRoute
            path="/board"
            authenticated={this.state.authenticated}
            component={Board}
          />
          <PublicRoute
            path="/login"
            authenticated={this.state.authenticated}
            component={Login}
          />
        </Switch>
      </Router>
    );
  }
}

export default App;
